var _rect, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCdi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 44",
    width: 220,
    height: 44,
    role: "img",
    "aria-label": "CDI Collectables",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 52,
    height: 41,
    fill: "#000",
    stroke: "#C9A86A",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 27.5,
    y: 30,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 20,
    letterSpacing: 2,
    fill: "#C9A86A"
  }, "CDI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 30,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: 1,
    fill: "#C9A86A"
  }, "Collectables")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCdi);
export default __webpack_public_path__ + "static/media/logo-cdi.5fff1b18f6c444f76a34c893e6d2af20.svg";
export { ForwardRef as ReactComponent };